"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisedMySQL = void 0;
const mysql_1 = require("mysql");
function promisedMySQL(pool, query, queryArgs) {
    return new Promise((resolve, reject) => {
        const formattedQuery = mysql_1.format(query, !!queryArgs && queryArgs.length > 0 ? queryArgs : []);
        pool.query(formattedQuery, (error, response) => {
            if (!!error) {
                reject(error);
            }
            resolve(response);
        });
    });
}
exports.promisedMySQL = promisedMySQL;
//# sourceMappingURL=MySQL.js.map